<script setup lang="ts">
import BaseModal from "~/components/Base/BaseModal.vue";
import ChatMessages from "~/components/Chat/ChatMessages.vue";
import ChatInput from "~/components/Chat/ChatInput.vue";

// -----------------------
// props & emits
// -----------------------
defineProps<{
  show: boolean;
}>();

const emit = defineEmits<{
  close: [];
}>();

// -----------------------
// composables
// -----------------------
const { t } = useI18n();
const { messages, isLoading, sendMessage, clearChat } = useChat();

// -----------------------
// helper functions
// -----------------------
const handleClose = () => {
  emit("close");
};

const handleSendMessage = async (content: string) => {
  await sendMessage(content);
};
</script>

<template>
  <BaseModal
    :show="show"
    :width="600"
    :height="700"
    :closeable="!isLoading"
    :autoclose="!isLoading"
    bgcolor="bg-white"
    @close="handleClose"
  >
    <div lang="hu">
      <div class="chat-modal h-full flex flex-col">
        <!-- Header -->
        <div class="flex justify-between items-center mb-4 pb-3 border-b">
          <h2 class="text-xl font-semibold text-gray-800">
            {{ t("chat.product_assistant") }}
          </h2>
          <button
            class="text-sm text-gray-500 hover:text-gray-700 transition-colors"
            @click="clearChat"
          >
            {{ t("chat.clear_chat") }}
          </button>
        </div>

        <!-- Messages -->
        <div class="flex-1 overflow-y-auto mb-4">
          <ChatMessages :messages="messages" :is-loading="isLoading" />
        </div>

        <!-- Input -->
        <div class="border-t pt-4">
          <ChatInput :is-loading="isLoading" @send="handleSendMessage" />
        </div>
      </div>
    </div>
  </BaseModal>
</template>

<style scoped>
.chat-modal {
  max-height: 80vh;
}
</style>
